import { render, staticRenderFns } from "./package-user-calendar-widget.vue?vue&type=template&id=2dbf199e&"
import script from "./package-user-calendar-widget.vue?vue&type=script&lang=js&"
export * from "./package-user-calendar-widget.vue?vue&type=script&lang=js&"
import style0 from "./package-user-calendar-widget.vue?vue&type=style&index=0&id=2dbf199e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports